// extracted by mini-css-extract-plugin
export default {"button":"button_button__27B0W","solid":"button_solid__xf8KS","outline":"button_outline__VB1Cq","red":"button_red__xlmCS","disabled":"button_disabled__TjgSn"};